import AgentDef from '@/components/agent/agentDef';
import AgentDefView from '@/components/agent/agentDefView';
import AgentInstance from '@/components/agent/agentInstance';
import NewAgentInstance from '@/components/agent/newAgentInstance';
import DataSourceDef from '@/components/dataSource/dataSourceDef';
import DataSourceInstance from '@/components/dataSource/dataSourceInstance';
import NewDataSourceInstance from '@/components/dataSource/newDataSourceInstance';
import NewUserAppInstance from '@/components/userApp/newUserApptInstance';
import UserAppDef from '@/components/userApp/userAppDef';
import UserAppInstance from '@/components/userApp/userAppInstance';
import BuildOptions from '@/pages/buildVisually/builderOptions';
import UserRequirementsPage from '@/pages/buildVisually/userRequirementsPage';
import UserSurveyPage from '@/pages/buildVisually/userSurveyPage';
import PipelineBuilderPage from '@/pages/buildVisually/pipelineBuilderPage';
import Dashboard from '@/pages/dashboard/dashboard';
import InstancesPage from '@/pages/instances/instancesPage';
import AdministrationPage from '@/pages/administration/administrationPage';
import ForgotPasswordPage from '@/pages/forgotPassword';
import Home from '@/pages/home/home';
import LoginPage from '@/pages/login';
import ResetPasswordPage from '@/pages/resetPassword';
import SignUpPage from '@/pages/signup';
import MarketplacePage from '@/pages/marketplace/marketplace';
import PrivacyPolicyPage from '@/pages/privacyPolicy';
import TermsAndConditionsPage from '@/pages/termsAndConditions';
import AssistantPage from '@/pages/assistant/assistantPage';
import { Navigate, Route, Routes } from 'react-router-dom';
import ProtectedRoute from './protectedRoute';

const Routing = () => {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/signup" element={<SignUpPage />} />
      <Route path="/forgotPassword" element={<ForgotPasswordPage />} />
      <Route path="/resetPassword" element={<ResetPasswordPage />} />
      <Route path="/marketplace" element={<MarketplacePage />} />
      <Route path="/privacy" element={<PrivacyPolicyPage />} />
      <Route path="/terms" element={<TermsAndConditionsPage />} />
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/instances"
        element={
          <ProtectedRoute>
            <InstancesPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/administration"
        element={
          <ProtectedRoute>
            <AdministrationPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/buildOptions"
        element={
          <ProtectedRoute>
            <BuildOptions />
          </ProtectedRoute>
        }
      />
      <Route
        path="/pipelineBuilder"
        element={
          <ProtectedRoute>
            <PipelineBuilderPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/builderUserSurvey/userRequirements"
        element={
          <ProtectedRoute>
            <UserRequirementsPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/builderUserSurvey/quickSurvey"
        element={
          <ProtectedRoute>
            <UserSurveyPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/builderUserSurvey/:surveyId"
        element={
          <ProtectedRoute>
            <UserSurveyPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/userAppInstance/:appDefId/:appInstanceId"
        element={
          <ProtectedRoute>
            <UserAppInstance />
          </ProtectedRoute>
        }
      />
      <Route
        path="/dataSourceInstance/:dataSourceDefId/:dataSourceInstanceId"
        element={
          <ProtectedRoute>
            <DataSourceInstance />
          </ProtectedRoute>
        }
      />
      <Route
        path="/agentInstance/:agentDefId/:agentInstanceId"
        element={
          <ProtectedRoute>
            <AgentInstance />
          </ProtectedRoute>
        }
      />
      <Route
        path="/createDataSourceInstance"
        element={
          <ProtectedRoute>
            <NewDataSourceInstance />
          </ProtectedRoute>
        }
      />
      <Route
        path="/createAgentInstance"
        element={
          <ProtectedRoute>
            <NewAgentInstance />
          </ProtectedRoute>
        }
      />
      <Route
        path="/createUserAppInstance"
        element={
          <ProtectedRoute>
            <NewUserAppInstance />
          </ProtectedRoute>
        }
      />
      <Route
        path="/userAppDef/:userAppDefId"
        element={
          <ProtectedRoute>
            <UserAppDef />
          </ProtectedRoute>
        }
      />
      <Route
        path="/dataSourceDef/:dataSourceDefId"
        element={
          <ProtectedRoute>
            <DataSourceDef />
          </ProtectedRoute>
        }
      />
      <Route
        path="/agentDef/:agentDefId"
        element={
          <ProtectedRoute>
            <AgentDef />
          </ProtectedRoute>
        }
      />
      <Route
        path="/agentDef/:agentDefId/view"
        element={
          <ProtectedRoute>
            <AgentDefView />
          </ProtectedRoute>
        }
      />
      <Route
        path="/newAgentDef"
        element={
          <ProtectedRoute>
            <AgentDef />
          </ProtectedRoute>
        }
      />
      <Route
        path="/assistant"
        element={
          <ProtectedRoute>
            <AssistantPage />
          </ProtectedRoute>
        }
      />
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
};

export default Routing;
